export default "__VITE_ASSET__CNE$NDoi__"